import { Injectable, signal } from '@angular/core';

export type AppTheme = 'theme-vinho' | 'theme-salvia' | 'theme-azul';

export const THEME_STORAGE_KEY = 'app-user-theme-v2';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  // Tema padrão: azul-marinho (decisão de 04/11/2026; antes era vinho).
  // A chave de storage mudou de versão para que todo mundo caia no azul uma
  // vez; quem trocar de novo na tela de login continua respeitado.
  private currentThemeSignal = signal<AppTheme>('theme-azul');
  
  constructor() {
    if (typeof window !== 'undefined') {
      const savedTheme = localStorage.getItem(THEME_STORAGE_KEY) as AppTheme;
      if (savedTheme && (savedTheme === 'theme-vinho' || savedTheme === 'theme-salvia' || savedTheme === 'theme-azul')) {
        this.setTheme(savedTheme);
      } else {
        this.setTheme('theme-azul');
      }
    }
  }

  getThemeSignal() {
    return this.currentThemeSignal;
  }

  setTheme(theme: AppTheme) {
    this.currentThemeSignal.set(theme);
    if (typeof window !== 'undefined') {
      localStorage.setItem(THEME_STORAGE_KEY, theme);
      this.applyTheme(theme);
    }
  }

  private applyTheme(theme: AppTheme) {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('theme-vinho', 'theme-salvia', 'theme-azul');
      document.body.classList.add(theme);
    }
  }
}
